import axios from '@/api/requests/axios'

export default {
  getAll: params => axios.get('/api/admin/v1/orders', { params }),
  getById: id => axios.get(`/api/admin/v1/orders/${id}`),

  getDeliveryStatus: id => axios.get(`/api/admin/v1/orders/${id}/delivery-status`),

  export: params => axios.get('/api/admin/v1/orders/export', { params, responseType: 'blob' }),
  getPaymentLog: id => axios.get(`/api/admin/v1/orders/payment-log/${id}`),
  getDeliveryLog: id => axios.get(`/api/admin/v1/orders/delivery-log/${id}`),
  getBakaiLog: id => axios.get(`/api/admin/v1/orders/bakai-log/${id}`),
  getIntegrationLog: id => axios.get(`/api/admin/v1/orders/logs/${id}`),

  getStatusHistory: id => axios
    .get(`/api/admin/v1/orders/status-history/${id}`, {
      validateStatus: status => (status >= 200 && status < 300) || status === 404,
    })
    .then(response => (response.status === 404
      ? Promise.reject(Object.assign(new Error('status history is not found'), { response }))
      : response)),
  getWorkflowData: id => axios.get(`/api/admin/v1/orders/workflow-data/${id}`),
  suspendWorkflow: id => axios.post(`/api/admin/v1/orders/suspend-workflow/${id}`),
}
